import React from 'react'
import styled from 'styled-components'
import TeamContainer from './TeamContainer'

const UnstyledTeam = ({ teams, className }) => (
    <section className={className} id="team">
        {teams.map((team) => (
            <TeamContainer key={team.id} team={team} />
        ))}
    </section>
)

const Team = styled(UnstyledTeam)`
    background-color: #f8f8f8;
    color: #13013d;
    overflow-x: hidden;
    padding: 0;
`

export default Team
